// moved to separate file alone because importing from tsx into a ts file causes jest to panic
export enum TabTypes {
	Live = 'Live',
	Upcoming = 'Upcoming',
	OnDemand = 'On Demand',
	All = 'All',
	TestEvents = 'Sandbox',
	Courses = 'Courses'
}